import * as Icons from "lucide-react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function ServiceCard({ service }) {
  const IconComp = Icons[service.icon] || Icons.Wrench;
  return (
    <Link
      to="/book"
      className="group relative flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_10px_30px_rgba(17,24,39,0.06)] hover:shadow-[0_14px_40px_rgba(17,24,39,0.12)] hover:border-pink-200 transition-shadow"
      data-testid={`service-card-${service.slug}`}
    >
      {service.image && (
        <div className="relative aspect-[16/10] overflow-hidden bg-slate-100">
          <img src={service.image} alt={service.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          <span className="absolute top-3 left-3 inline-flex h-9 w-9 items-center justify-center rounded-xl shadow-sm" style={{ background: "var(--icrack-magenta-soft)" }}>
            <IconComp className="h-4.5 w-4.5" style={{ color: "var(--icrack-magenta-deep)" }} />
          </span>
        </div>
      )}
      <div className="p-5">
        <h3 className="text-base font-semibold text-slate-900">{service.title}</h3>
        <p className="mt-1 text-sm text-slate-600 leading-relaxed">{service.short}</p>
        <span className="mt-4 inline-flex items-center text-sm font-semibold" style={{ color: "var(--icrack-magenta-deep)" }}>
          Book this repair <ChevronRight className="h-4 w-4 ml-0.5 group-hover:translate-x-0.5 transition-transform" />
        </span>
      </div>
    </Link>
  );
}
